$(document).ready(function(){
  $('#cart__drawer #cart_drawer-close,#cart__drawer_overlay').click(function(){
    $('body').removeClass('cart-drawr_is--open');
    $('#cart__drawer').removeClass('cart_open')
    $('#cart__drawer_overlay').hide();
  });

  function open_cart(){
    $('body').addClass('cart-drawr_is--open');
    $('#cart__drawer').addClass('cart_open');
    $('#cart__drawer_overlay').show();
  }

  $(document).on('click','.cart__item_qty .minus',function(){
    var current = $(this).siblings('input[type=number]').val();
    var min = $(this).siblings('input[type=number]').attr('min');
    if(current > min && current > -1 ){
      $(this).siblings('input[type=number]').val(current - 1).trigger('change');
    }
  });
  $(document).on('click','.cart__item_qty .plus',function(){
    var current = parseInt($(this).siblings('input[type=number]').val());
    $(this).siblings('input[type=number]').val(current + 1).trigger('change');
  });
  
  $('.cart-link.js-drawer-open-button-right').click(function(e){e.preventDefault();open_cart();});
  function shipping_bar(){
    if($('#cart__drawer-shipping').length){
      $.getJSON('/cart.js',function(cart){
        var subtotal = (cart.total_price)/100;
        var shipp_price = $('#cart__drawer-shipping').data('shipp');
        var free_price = $('#cart__drawer-shipping').data('free');
        var data_prod = $('#cart__drawer-shipping').data('prod');
        var steps = $('#cart__drawer-shipping').hasClass('one_step')?100 : 66.66;
        if(subtotal >= free_price && free_price){
          $('#shipping__progress .shipping__progress--remain').css('width','100%')
          $('#cart__drawer-shipping .bar--text.for_free--shipping').addClass('success');
          $('#cart__drawer-shipping .bar--text.for_free--gift').addClass('success');
          if(!$('.cart__items--container.cart_item_free_product').length){
            let formData = {'items': [{'id': data_prod,'quantity': 1}]};
            fetch(window.Shopify.routes.root + 'cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(formData)
            })
            .then(response => response.json())
            .then((response) => {
              reload_cart_drawer();
              // $('.cart__drawer--footer .cart_free_prod-withdraw').removeClass('hidden');
            })
            .catch((error) => {
              console.error('Error:', error);
            });
          }
          
        }else if(subtotal > shipp_price && free_price && !shipp_price){
          $('#shipping__progress .shipping__progress--remain').css('width','100%')
        }
        else if(subtotal <= shipp_price && shipp_price){
          $('#cart__drawer-shipping .bar--text.for_free--shipping.success').removeClass('success');
          var width = ((subtotal*steps)/shipp_price);
          $('#shipping__progress .shipping__progress--remain').css('width',width+'%');
        }
        else if(subtotal > shipp_price && shipp_price && !free_price){
          $('#cart__drawer-shipping .bar--text.for_free--shipping').addClass('success');
          $('#shipping__progress .shipping__progress--remain').css('width','100%')
        }
        else if(subtotal > shipp_price && subtotal < free_price && shipp_price && free_price){
          $('#cart__drawer-shipping .bar--text.for_free--shipping').addClass('success');
          var width = ((subtotal - shipp_price)*33.33)/(free_price - shipp_price)+steps;
          $('#shipping__progress .shipping__progress--remain').css('width',width+'%');
        }
        else if(subtotal < free_price && !shipp_price && free_price){
          var width = ((subtotal*steps)/free_price);
          $('#shipping__progress .shipping__progress--remain').css('width',width+'%');
        }
        if($('.cart__items--container.cart_item_free_product').length && subtotal < free_price){
          $('#cart__drawer-shipping .bar--text.for_free--gift').removeClass('success');
            $('.cart__items--container.cart_item_free_product').find('.cart__item_remove').click();
        }
      });
    }
  }
  shipping_bar();
  if($('#cart--cross_sell .drawer__reco_body').html().trim() == ''){
    $('#cart--cross_sell').hide();
  }else{
    $('#cart--cross_sell').show();
  }
  function reload_cart_drawer(){
    fetch(window.Shopify.routes.root + "?section_id=cart_drawer")
      .then(responseText => responseText.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        $(html).find('#cart__drawer').hasClass('cart_is--empty')? $('#cart__drawer').addClass('cart_is--empty') : $('#cart__drawer').removeClass('cart_is--empty');
        $('#cart__drawer--body').html(html.getElementById('cart__drawer--body').innerHTML);
        $('#cart_checkout--form').html(html.getElementById('cart_checkout--form').innerHTML);
        if($(html).find('#remain_free-gift_text').length){
          $('#remain_free-gift_text').html(html.getElementById('remain_free-gift_text').innerHTML);
        }
        $(html).find('#cart--cross_sell .drawer__reco_body').html().trim() == '' ? $('#cart--cross_sell').hide() : $('#cart--cross_sell').show();
        $('#cart__drawer').hasClass('cart_is--empty') ? $('.cart-link__bubble').removeClass('cart-link__bubble--visible') : $('.cart-link__bubble').addClass('cart-link__bubble--visible');
        shipping_bar();
        open_cart();
    });
  }

  $(document).on('click','.add__to--cart-btn',function(e){
    e.preventDefault();
    var id = $(this).data('variant-id');
    var quantity = 1;
    if($(this).parents('.drawer__reco_item').length){
      quantity = $(this).parents('.drawer__reco_item').find('input[name="quantity"]').val();
    }
    let formData = {
        'items': [{
        'id': id,
        'quantity': quantity
      }]
    };
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => response.json())
    .then((response) => {
      reload_cart_drawer();
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  });

  $(document).on('click','.cart__item_remove',function(e){
    e.preventDefault();
    var id = $(this).data('line');
    var data = {
      'line': id,
      'quantity': 0
    };
    fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    }).then((response) => {
      reload_cart_drawer();
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  });

  $(document).on('change','.cart__items--container .cart__item_qty input[name="quantity"]',function(e){
    e.preventDefault();
    var val = $(this).val(),
      id = $(this).data('line'),
      data = {
        'line': id,
        'quantity': val
      };
    fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    }).then((response) => {
      reload_cart_drawer();
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  });

  $(document).on('submit','form[action="/cart/add"].product-single__form',function(e){
    e.preventDefault();
    let formData = new FormData(document.querySelector('form[action="/cart/add"].product-single__form'));
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    })
    .then(response => response.json())
    .then((response) => {
      reload_cart_drawer();
    })
    .catch((error) => {
      console.error('Error:', error);
    });    
  });
  
});